import UpcEditor from "../symbols/upcEditor";

export interface IState {
  selectedTab: number;
}
const initialState: IState = {
  selectedTab: 0,
};

function UpcEditorReducer(state = initialState, action: any) {
  switch (action.type) {
    case UpcEditor.SET_SELECTED_TAB:
      return { ...state, selectedTab: action.payload };
    default:
      return state;
  }
}
export default UpcEditorReducer;
